<mat-card class="service-offer-card" (click)="this.titleClick.emit()">
  <!-- Visual Header -->
  <div class="card-visual">
    <div class="visual-label">
      <mat-icon>cloud</mat-icon>
      <span>{{ 'asset.card.typeLabel' | transloco }}</span>
    </div>
    <svg class="visual-icon" width="110" height="100" viewBox="0 0 110 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 65C20 65 15 58 15 50C15 42 22 36 30 36C30 24 40 15 55 15C70 15 80 24 80 36C88 36 95 42 95 50C95 58 88 65 80 65Z" stroke="currentColor" stroke-width="2" opacity="0.5"/>
      <rect x="35" y="40" width="20" height="2" rx="1" fill="currentColor" opacity="0.3"/>
      <rect x="35" y="46" width="30" height="2" rx="1" fill="currentColor" opacity="0.25"/>
      <rect x="35" y="52" width="25" height="2" rx="1" fill="currentColor" opacity="0.2"/>
      <path d="M55 75V60M48 67L55 60L62 67" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.45"/>
    </svg>
  </div>

  <mat-card-content class="service-offer-card-content">
    <div class="card-main-flex-container">
      <div class="card-details-flex-column">
        <div class="card-action-button-wrapper">
          <div class="card-action-button" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="-1">
            <ng-content select="[actionButton]"></ng-content>
          </div>
        </div>

        <mat-card-title>
          {{ title() | emptyValue }}
        </mat-card-title>

        <div class="card-metadata-row">
          <span class="metadata-item">
            <mat-icon>category</mat-icon>
            <span>{{
              translateEnum(serviceType() || '', 'asset.enum.serviceType') | emptyValue
            }}</span>
          </span>
          <span class="metadata-item">
            <mat-icon>business_center</mat-icon>
            <span>{{ sovereign() | emptyValue }}</span>
          </span>
        </div>

        <div class="card-tags-row">
          <mat-icon class="tag-icon">sell</mat-icon>
          <div class="tags-container" #chipRow>
            <mat-chip-listbox aria-label="Keywords">
              @for (tag of visibleTags; track tag) {
                <mat-chip class="entity-card-chip">
                  {{ tag }}
                </mat-chip>
              }

              @if (hiddenTagCount > 0) {
                <mat-chip
                  class="entity-card-chip hidden-tag-chip"
                  [matMenuTriggerFor]="overflowMenu"
                  (click)="$event.stopPropagation()"
                >
                  +{{ hiddenTagCount }}
                </mat-chip>
              }
            </mat-chip-listbox>

            <mat-menu #overflowMenu="matMenu" [overlapTrigger]="false" class="tag-overflow-menu">
              <div (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" tabindex="-1">
                <div class="overflow-menu-header">Weitere Tags</div>
                <mat-chip-listbox aria-label="Weitere Tags">
                  @for (tag of tagList().slice(visibleTags.length); track tag) {
                    <mat-chip class="entity-card-chip">
                      {{ tag }}
                    </mat-chip>
                  }
                </mat-chip-listbox>
              </div>
            </mat-menu>
          </div>
        </div>

        <p class="card-description">
          {{ description() | emptyValue | truncate: 120 }}
          @if (isTruncated(description())) {
            <span class="read-more">Mehr lesen</span>
          }
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
